import { render, staticRenderFns } from "./quaquay.vue?vue&type=template&id=6f87ded6&scoped=true&"
import script from "./quaquay.vue?vue&type=script&lang=js&"
export * from "./quaquay.vue?vue&type=script&lang=js&"
import style0 from "./quaquay.vue?vue&type=style&index=0&id=6f87ded6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../usr/lib/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f87ded6",
  null
  
)

export default component.exports